module.exports = __webpack_public_path__ + "static/media/Value_Thinking_CheckList.f12c45f0.png";